"use client";
import axios from "axios";
import PropTypes from "prop-types";
import { createContext, useCallback, useEffect, useState } from "react";

// Create Context
export const AppContext = createContext();

// Provider Component
export const AppProvider = ({ children }) => {
  const uri = "https://admin.cbsg-bd.org/api/";
  const [loading, setLoading] = useState(true);
  const [About, setAbout] = useState([{ data: [] }]);
  const [images, setImages] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [IntroData, SetIntroData] = useState([]);
  const [homeText, setHomeText] = useState([]);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      const [bannerRes, assignmentRes, aboutRes, homeTextRes] = await Promise.all([
        axios.get(`${uri}home-banners/`),
        axios.get(`${uri}assignments/`),
        axios.get(`${uri}about-us/`),
        axios.get(`${uri}company-profile/`),
      ]);

      setImages(bannerRes.data);
      setAssignments(assignmentRes.data);
      setAbout(aboutRes.data[0]);
      setHomeText(homeTextRes.data[0]);

      SetIntroData({
        practice_caption: homeTextRes.data[0]?.practice_caption,
        organization_development_text: homeTextRes.data[0]?.organization_development_text,
        research_evaluation_text: homeTextRes.data[0]?.research_evaluation_text,
      });
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [uri]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <AppContext.Provider value={{ uri, images, loading, assignments, About, SetIntroData, IntroData, homeText, error }}>
      {children}
    </AppContext.Provider>
  );
};

// PropTypes Validation
AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppProvider;
